import { ReactNode, useCallback, useRef, useState } from 'react';
import { ViewerContext } from 'app/agriculture/contexts/ViewerContext/ViewerContext';

const ANZ_bbox = Cesium.Rectangle.fromDegrees(100, -48, 186, 0);

export function ViewerProvider({
    children,
    initOptions,
    initView = { destination: ANZ_bbox },
}: {
    children: ReactNode;
    initOptions: Cesium.Viewer.ConstructorOptions;
    initView?: Parameters<Cesium.Viewer['camera']['setView']>[0];
}) {
    const [viewer, setViewer] = useState<Cesium.Viewer | null>(null);
    const options = useRef(initOptions);
    const view = useRef(initView);

    const setViewerRef = useCallback((node: HTMLDivElement | null) => {
        if (node == null) return;
        const viewer = new Cesium.Viewer(node, options.current);
        viewer.camera.setView(view.current);
        setViewer(viewer);
    }, []);

    return (
        <ViewerContext.Provider value={{ viewer, setViewerRef }}>{children}</ViewerContext.Provider>
    );
}
